import React, { useState, useEffect } from "react";
export default function Dashboard() {
  const [invoices, setInvoices] = useState([]);
  const [purchases, setPurchases] = useState([]);
  const [transactions, setTransactions] = useState([]);
  
  const d = new Date();
  const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).toISOString().split('T')[0];
  const today = d.toISOString().split('T')[0];
  
  const [startDate, setStartDate] = useState(firstDay);
  const [endDate, setEndDate] = useState(today);

  useEffect(() => {
    fetch("/api/invoices").then(r=>r.json()).then(d=>setInvoices(Array.isArray(d)?d:[]));
    fetch("/api/purchases").then(r=>r.json()).then(d=>setPurchases(Array.isArray(d)?d:[]));
    fetch("/api/transactions").then(r=>r.json()).then(d=>setTransactions(Array.isArray(d)?d:[]));
  }, []);

  const isDateInRange = (dateStr) => {
    if(!dateStr) return false;
    if(startDate && dateStr < startDate) return false;
    if(endDate && dateStr > endDate) return false;
    return true;
  };

  const filteredInvoices = invoices.filter(i => isDateInRange(i.date));
  const filteredPurchases = purchases.filter(p => isDateInRange(p.date));
  const filteredTransactions = transactions.filter(t => isDateInRange(t.date));

  // 1. GST Payment (Sales Revenue from GST Invoices)
  const gstPayment = filteredInvoices.reduce((sum, inv) => sum + Number(inv.total || 0), 0);
  
  // 2. GST Output & 3. GST Input
  let gstOutput = 0;
  filteredInvoices.forEach(inv => {
    if(inv.items && Array.isArray(inv.items)) {
       inv.items.forEach(it => {
          const base = Number(it.qty) * Number(it.rate);
          gstOutput += base * (((it.tax_rate === 0 || it.tax_rate === "0") ? 0 : (Number(it.tax_rate) || 18)) / 100);
       });
    }
  });
  const gstInput = filteredPurchases.reduce((sum, p) => sum + Number(p.gst_amount || 0), 0);

  // 4. Purchase
  const totalPurchase = filteredPurchases.reduce((sum, p) => sum + Number(p.total_amount || 0), 0);

  // 5. NON GST Payment (Income)
  const nonGstPayment = filteredTransactions.filter(t=>t.type==='Income').reduce((sum, t) => sum + Number(t.amount || 0), 0);

  // 6. Total Income (GST Payment + Non GST Payment)
  const totalIncome = gstPayment + nonGstPayment;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 bg-white p-4 rounded shadow border-l-4 border-blue-600">
         <h1 className="text-2xl font-bold text-gray-800">Business Dashboard</h1>
         <div className="flex flex-wrap items-center gap-4 mt-4 md:mt-0 bg-gray-50 p-2 rounded border">
            <div className="flex items-center gap-2">
               <label className="font-bold text-gray-600 text-sm">From Date:</label>
               <input type="date" className="border p-1 rounded font-bold text-sm cursor-pointer" value={startDate} onChange={(e)=>setStartDate(e.target.value)} />
            </div>
            <div className="flex items-center gap-2">
               <label className="font-bold text-gray-600 text-sm">To Date:</label>
               <input type="date" className="border p-1 rounded font-bold text-sm cursor-pointer" value={endDate} onChange={(e)=>setEndDate(e.target.value)} />
            </div>
            <button onClick={()=>{setStartDate(""); setEndDate("");}} className="bg-gray-300 px-3 py-1 text-sm rounded font-bold hover:bg-gray-400 text-gray-800">Clear</button>
         </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-8">
         <div className="bg-white p-6 rounded-lg shadow-lg border-l-8 border-indigo-500">
            <p className="text-gray-500 text-sm font-bold uppercase tracking-wider">Total Income</p>
            <p className="text-3xl font-extrabold text-indigo-700 mt-2">₹{totalIncome.toFixed(2)}</p>
         </div>
         <div className="bg-white p-6 rounded-lg shadow-lg border-l-8 border-blue-500">
            <p className="text-gray-500 text-sm font-bold uppercase tracking-wider">GST Payment (Sales)</p>
            <p className="text-3xl font-extrabold text-blue-700 mt-2">₹{gstPayment.toFixed(2)}</p>
         </div>
         <div className="bg-white p-6 rounded-lg shadow-lg border-l-8 border-green-500">
            <p className="text-gray-500 text-sm font-bold uppercase tracking-wider">NON GST Payment</p>
            <p className="text-3xl font-extrabold text-green-700 mt-2">₹{nonGstPayment.toFixed(2)}</p>
         </div>
         <div className="bg-white p-6 rounded-lg shadow-lg border-l-8 border-yellow-500">
            <p className="text-gray-500 text-sm font-bold uppercase tracking-wider">GST Output</p>
            <p className="text-3xl font-extrabold text-gray-800 mt-2">₹{gstOutput.toFixed(2)}</p>
         </div>
         <div className="bg-white p-6 rounded-lg shadow-lg border-l-8 border-purple-500">
            <p className="text-gray-500 text-sm font-bold uppercase tracking-wider">GST Input</p>
            <p className="text-3xl font-extrabold text-gray-800 mt-2">₹{gstInput.toFixed(2)}</p>
         </div>
         <div className="bg-white p-6 rounded-lg shadow-lg border-l-8 border-red-500">
            <p className="text-gray-500 text-sm font-bold uppercase tracking-wider">Purchase</p>
            <p className="text-3xl font-extrabold text-red-700 mt-2">₹{totalPurchase.toFixed(2)}</p>
         </div>
      </div>
    </div>
  );
}
